module.exports = __webpack_public_path__ + "static/media/red-mobile-small-blob.876fddf7.svg";